import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { AppBar, Toolbar, Button, Link, Box, Stack } from "@mui/material";
import { Link as ScrollLink } from "react-scroll";
import PersonIcon from "@mui/icons-material/Person";
import ReactGA from "react-ga4";

import logoUrl from "../assets/images/logo-svg1.svg";

function Navbar() {

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar className="App-header">
          <Link component={RouterLink} to="/" sx={{ mr: 2 }}>
            <Box
              sx={{
                width: "auto",
                height: { xs: "40px", sm: "40px", md: "60px", lg: "60px" },
              }}
            >
              <img
                src={logoUrl}
                alt="Logo"
                style={{ width: "100%", height: "100%" }}
              />
            </Box>
          </Link>
          <Box sx={{ flexGrow: 1 }} />
          <Box
            sx={{ display: { xs: "none", md: "flex" } }}
            className="App-link"
          >
            <Stack direction="row" spacing={2}>
              <ScrollLink
                to="vantagens"
                hashSpy={true}
                smooth={true}
                duration={500}
                offset={-1950}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Button color="inherit">Como funciona</Button>
              </ScrollLink>
              <ScrollLink
                to="vantagens"
                hashSpy={true}
                smooth={true}
                duration={500}
                offset={-220}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Button color="inherit">Vantagens</Button>
              </ScrollLink>
              <ScrollLink
                to="perguntas-frequentes"
                hashSpy={true}
                smooth={true}
                duration={500}
                offset={-50}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Button color="inherit">Perguntas frequentes</Button>
              </ScrollLink>
            </Stack>
          </Box>
          <Stack direction="row" spacing={2}>
            <Link component={RouterLink} to="https://parceiro.wash.app.br/">
              <Button
                component="label"
                variant="outlined"
                size="large"
                fullWidth
                disableElevation
                startIcon={<PersonIcon />}
                onClick={() => {
                  ReactGA.event("login_click", {
                    event: 'login_click',
                    button_id: 'login',
                    page_path: window.location.pathname
                  })
                }}
              >
                Entrar
              </Button>
            </Link>
            {/* <Link component={RouterLink} to="/SignUp">
                            <Button component="label" variant="contained" color='primary' size="large" fullWidth disableElevation>
                                Cadastrar
                            </Button>
                        </Link> */}
          </Stack>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Navbar;
